export const getExtraProfileDataFromCustomAttributes = (customAttr) => {
    if (!customAttr)
        return {};
    const keys = Object.keys(customAttr);
    const extra = {};
    keys.forEach((key) => {
        if (typeof customAttr[key] === "string") {
            extra[key] = customAttr[key];
        }
        else {
            extra[key] = JSON.stringify(customAttr[key]);
        }
    });
    return extra;
};
//# sourceMappingURL=getExtraProfileDataFromCustomAttributes.js.map